import qs from "qs"

import {CommunicationPreferences} from "../types"

/**
 * @description:
 * Retrieves initial state for contact preferences
 * *
 */

export const getBasePreferences = (): CommunicationPreferences => ({
  free_perks: false,
  weekly_newsletter: false,
  recognition_alerts: false,
  wellness_alerts: false,
  hr_tips: false,
  product_content: false,
  alcohol: false,
  fathers_day: false,
  mothers_day: false
})

/**
 * @description:
 * Builds updated state for contact preferences,
 * based on data from marketing profile
 * *
 */

export const buildPreferencesFromProfile = (
  contactPreferences: CommunicationPreferences,
  isEnabled: boolean,
  unsubscribedPreferences: string[]
) => {
  const resolvedPreferences: {[key: string]: boolean} = {}

  if (unsubscribedPreferences && unsubscribedPreferences.length) {
    unsubscribedPreferences.forEach((p) => {
      resolvedPreferences[p] = false
    })

    Object.keys(contactPreferences).forEach((p) => {
      if (!unsubscribedPreferences.includes(p)) {
        resolvedPreferences[p] = true
      }
    })
  } else {
    Object.keys(contactPreferences).forEach((p) => {
      resolvedPreferences[p] = isEnabled
    })
  }

  return resolvedPreferences
}

export const getPreferenceFromUrl = (): keyof CommunicationPreferences | undefined => {
  return qs.parse(location.search, {ignoreQueryPrefix: true})?.utm_message_type
}

export const isCommunicationMethodEnabled = (preferences: CommunicationPreferences) => {
  return Object.keys(preferences).some((p) => preferences[p as keyof CommunicationPreferences])
}

export const isCommunicationMethodFullyEnabled = (preferences: CommunicationPreferences) => {
  return Object.values(preferences).every((p) => p)
}
